import React, { useContext } from 'react';
import { InboundContext } from '../../../../context/InboundContext';
import { FormGroup } from '../../../common';
import { Heading } from '../../../styledComponents';
import { InstagramIcon, YoutubeIcon, TiktokIcon, FacebookIcon, TwitterIcon, BlogIcon } from '../../../../assets/icons';
import styles from '../FormContainer.module.css';

type SocialMediaLinksType = {
  youtube: string;
  instagram: string;
  tiktok: string;
  facebook: string;
  twitter: string;
  blog: string;
};

type SocialMediaLinksProps = {
  socialMediaLinks: SocialMediaLinksType;
  setSocialMediaLinks: React.Dispatch<React.SetStateAction<SocialMediaLinksType>>;
};

export default function SocialMediaLinks({ socialMediaLinks, setSocialMediaLinks }: SocialMediaLinksProps) {
  const { inboundData, t } = useContext(InboundContext);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSocialMediaLinks({ ...socialMediaLinks, [name]: value });
  };

  return (
    <div>
      {(inboundData?.formSetupPage?.socialLinks?.instagram ||
        inboundData?.formSetupPage?.socialLinks?.youtube ||
        inboundData?.formSetupPage?.socialLinks?.tiktok ||
        inboundData?.formSetupPage?.socialLinks?.facebook ||
        inboundData?.formSetupPage?.socialLinks?.twitter ||
        inboundData?.formSetupPage?.socialLinks?.blog) && (
        <div className={styles.formSection}>
          <Heading as="h3" fontWeight="500" fontSize="16px" color="#353535" textTransform="uppercase">
            {t('socialMediaHeader')}
          </Heading>
          {inboundData?.formSetupPage?.socialLinks?.instagram && (
            <FormGroup
              id="instagram"
              name="instagram"
              label="Instagram"
              type="text"
              placeholder={t('usernamePlaceholder')}
              value={socialMediaLinks.instagram}
              onChange={handleInputChange}
              required={
                !inboundData?.formSetupPage?.socialLinks?.tiktok && !inboundData?.formSetupPage?.socialLinks?.youtube
              }
              errorText=""
              icon={<InstagramIcon />}
              leftLabel="https://instagram.com/"
            />
          )}
          {inboundData?.formSetupPage?.socialLinks?.tiktok && (
            <FormGroup
              id="tiktok"
              name="tiktok"
              label="TikTok"
              type="text"
              placeholder={`@${t('usernamePlaceholder')}`}
              value={socialMediaLinks.tiktok}
              onChange={handleInputChange}
              errorText=""
              required={
                !inboundData?.formSetupPage?.socialLinks?.instagram && !inboundData?.formSetupPage?.socialLinks?.youtube
              }
              icon={<TiktokIcon />}
              leftLabel="https://tiktok.com/"
            />
          )}
          {inboundData?.formSetupPage?.socialLinks?.youtube && (
            <FormGroup
              id="youtube"
              name="youtube"
              label="Youtube"
              type="text"
              placeholder="https://youtube.com/channel"
              value={socialMediaLinks.youtube}
              onChange={handleInputChange}
              errorText=""
              required={
                !inboundData?.formSetupPage?.socialLinks?.instagram && !inboundData?.formSetupPage?.socialLinks?.tiktok
              }
              icon={<YoutubeIcon />}
            />
          )}
          {inboundData?.formSetupPage?.socialLinks?.facebook && (
            <FormGroup
              id="facebook"
              name="facebook"
              label="Facebook"
              type="text"
              placeholder="https://facebook.com/page"
              value={socialMediaLinks.facebook}
              onChange={handleInputChange}
              errorText=""
              icon={<FacebookIcon />}
            />
          )}
          {inboundData?.formSetupPage?.socialLinks?.twitter && (
            <FormGroup
              id="twitter"
              name="twitter"
              label="Twitter"
              type="text"
              placeholder={t('usernamePlaceholder')}
              value={socialMediaLinks.twitter}
              onChange={handleInputChange}
              errorText=""
              icon={<TwitterIcon />}
              leftLabel="https://twitter.com/"
            />
          )}
          {inboundData?.formSetupPage?.socialLinks?.blog && (
            <FormGroup
              id="blog"
              name="blog"
              label="Blog"
              type="url"
              placeholder="https://myblog.com"
              value={socialMediaLinks.blog}
              onChange={handleInputChange}
              errorText=""
              icon={<BlogIcon />}
            />
          )}
        </div>
      )}
    </div>
  );
}
